// src/stores/actions/event.js

// TIPOS (mantenho os nomes legados para compatibilidade com o seu código)
export const CREATE_EVENT_ACTION = 'CREATE_EVENT_ACTION'
export const GET_EVENTS_ACTION = 'GET_EVENTS_ACTION'
export const DELETE_EVENT_ACTION = 'DELETE_EVENT_ACTION'
export const UPDATE_EVENT_ACTION = 'UPDATE_EVENT_ACTION'
export const GET_ACIVITY_ACTION = 'GET_ACIVITY_ACTION'
export const GET_EVENT_ACTION = 'GET_EVENT_ACTION'

// ACTION CREATORS
export const createEventAction = (data, callback) => ({
  type: CREATE_EVENT_ACTION,
  data,
  callback,
})

export const getEventsAction = (params, callback) => {
  // permite chamar com getEvents(callback) sem passar params
  if (typeof params === 'function' && callback === undefined) {
    return { type: GET_EVENTS_ACTION, params: undefined, callback: params }
  }
  return { type: GET_EVENTS_ACTION, params, callback }
}

export const deleteEventAction = (params, callback) => ({
  type: DELETE_EVENT_ACTION,
  params,
  callback,
})

export const updateEventAction = (data, callback) => ({
  type: UPDATE_EVENT_ACTION,
  data,
  callback,
})

// Detalhe de um evento (se precisar em alguma tela)
export const getEventAction = (params, callback) => ({
  type: GET_EVENT_ACTION,
  params,
  callback,
})

// Lista de ATIVIDADES para o <ConfirmEventModal/> popular o select
export const getActivityAction = (callback) => ({
  type: GET_ACIVITY_ACTION, // (mantendo o mesmo nome esperado dentro do modal)
  callback,
})
